export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;

export const PASSWORD_CRITERIA = [
  { id: 'length', label: 'Au moins 8 caractères', test: (value: string) => value.length >= PASSWORD_MIN_LENGTH },
  { id: 'uppercase', label: 'Une majuscule', test: (value: string) => /[A-Z]/.test(value) },
  { id: 'digit', label: 'Un chiffre', test: (value: string) => /[0-9]/.test(value) },
  { id: 'special', label: 'Un caractère spécial', test: (value: string) => /[^A-Za-z0-9]/.test(value) },
];

export const validatePassword = (value: string): string | true => {
  if (value.length > PASSWORD_MAX_LENGTH) return 'Le mot de passe est trop long';

  const failing = PASSWORD_CRITERIA.filter((criterion) => !criterion.test(value));

  return failing.length === 0 ? true : 'Le mot de passe ne respecte pas tous les critères';
};
